module.exports = __webpack_public_path__ + "img/LF.15e358bd.png";